import { render, staticRenderFns } from "./DisputeCreationConfirmationModal.vue?vue&type=template&id=051e5118"
import script from "./DisputeCreationConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DisputeCreationConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./DisputeCreationConfirmationModal.vue?vue&type=style&index=0&id=051e5118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports